import React from 'react';

import styled from '@emotion/styled';

import { COLORS, Tooltip } from '@clutter/clean';

import infoTooltip from '@portal/images/info_tooltip.svg';

export const TooltipList = styled.ul`
  span {
    color: ${COLORS.panther};
  }
  li {
    color: ${COLORS.tealPrimary};
  }
`;

export const InfoTooltip: React.FC<{
  text: React.ReactNode;
}> = ({ text }) => (
  <Tooltip arrow text={text}>
    <img src={infoTooltip} />
  </Tooltip>
);
